import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'FilterTitles', pure: false })

export class FilterTitlesPipe implements PipeTransform {
  transform(titles, category) {
    return titles.filter(title => title.category === category);
  }
}
